import wire from '../wire';
import template from './caption-editor.html';
import Controller from './caption-editor-controller';

var module = wire(
  'caption-editor',
  template,
  Controller,
  'CaptionEditorController',
  '/caption-editor/:broadcastId'
);

require('./directives'); //<-- require *After* we create angular module above

export default module;



// WEBPACK FOOTER //
// ./app/pages/caption-editor/_index.js